// extracted by mini-css-extract-plugin
module.exports = {"responsiveLayout":"ResponsiveLayout-module--responsiveLayout--35yyx"};